export default __webpack_public_path__ + "content/media/22.1bc96f1a.jpg";